var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-s-svgrepo-com 1",
    clipPath: "url(#clip0_4854_22108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31055 47.0532V49.25C8.31055 51.3211 9.9895 53 12.0605 53H49.5605C51.6317 53 53.3105 51.3211 53.3105 49.25V32.0532C53.3105 31.0588 52.9153 30.1047 52.2122 29.4016L48.4622 25.6516C46.9978 24.1873 44.6233 24.1873 43.1589 25.6516L33.4622 35.3484C31.9978 36.8128 29.6233 36.8128 28.1589 35.3484L25.9622 33.1516C24.4978 31.6873 22.1234 31.6873 20.6589 33.1516L9.40889 44.4016C8.70565 45.1048 8.31055 46.0588 8.31055 47.0532ZM17.6855 23C20.7922 23 23.3105 20.4816 23.3105 17.375C23.3105 14.2684 20.7922 11.75 17.6855 11.75C14.5789 11.75 12.0605 14.2684 12.0605 17.375C12.0605 20.4816 14.5789 23 17.6855 23ZM12.0605 0.5H49.5605C55.7739 0.5 60.8105 5.53681 60.8105 11.75V49.25C60.8105 55.4634 55.7739 60.5 49.5605 60.5H12.0605C5.84736 60.5 0.810547 55.4634 0.810547 49.25V11.75C0.810547 5.53681 5.84736 0.5 12.0605 0.5Z",
    fill: "#A3A3A3",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4854_22108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.810547 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefultImage);
export default __webpack_public_path__ + "static/media/defultImage.8b514ee0c96a1b5e53543921ed220046.svg";
export { ForwardRef as ReactComponent };